
import { mediaApi, termsApi, getAuthToken, PROJECT_URL } from './axiosInstance';
import axios from 'axios';
import { request,WP_MEDIA_API_URL,API_URL } from './axiosInstance';

// Get folder ID by name using Premio Folders' media_folder taxonomy
 export const getFolderIdByName = async (folderName) => {
    try {
        const response = await termsApi.get('', {
            params: {
                search: folderName,
                per_page: 1,
            },
        });

        const folder = response.data.find(
            (f) => f.name.toLowerCase() === folderName.toLowerCase()
        );

        if (!folder) {
            throw new Error(`Folder "${folderName}" not found`);
        }

        return folder.id;
    } catch (error) {
        console.error('Error fetching folder ID by name:', {
            folderName,
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            url: error.config?.url,
            headers: error.config?.headers,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch folder ID');
    }
};

// Upload an image to a Premio Folders folder
export async function uploadImageToMedia(file, folderName, altText = '', authorId = null) {
    try {
        const folderId = await getFolderIdByName(folderName);
        const formData = new FormData();
        formData.append('file', file, file.name);
        if (altText) formData.append('alt_text', altText);
        formData.append('media_folder', folderId);
        if (authorId) formData.append('author', authorId);
        console.log('Uploading to media:', formData);

        const uploadResponse = await mediaApi.post('', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return {
            id: uploadResponse.data.id,
            url: uploadResponse.data.source_url,
        };
    } catch (error) {
        console.error('Error uploading image to Premio folder:', {
            fileName: file.name,
            fileType: file.type,
            fileSize: file.size,
            folderName,
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            url: error.config?.url,
            headers: error.config?.headers,
        });
        throw new Error(error.response?.data?.message || 'Failed to upload image to folder');
    }
}

// Upload prescription to a Premio Folders folder
// Upload a prescription via custom/v1/prescriptions.
//
// Previously POSTed to wp/v2/media, which needs `upload_files` — an admin capability
// the `customer` role lacks, so this only worked because the storefront ran as an
// Administrator. The replacement is scoped: images and PDFs only (checked by real
// MIME type, not filename), 10MB cap, filed under the Prescription folder and owned
// by the uploader.
//
// authorId and folderName are accepted for call-site compatibility and ignored —
// the server derives the owner from the bearer token.
export const uploadPrescription = async (file, authorId, folderName = 'Prescription') => {
    if (!file) {
        throw new Error('No file provided for upload');
    }
    const token = await getAuthToken();
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axios.post(
            `${PROJECT_URL}wp-json/custom/v1/prescriptions`,
            formData,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return {
            id: response.data.id,
            url: response.data.url,
            title: response.data.title,
        };
    } catch (error) {
        console.error('Error uploading prescription:', {
            response: error.response?.data,
            status: error.response?.status,
        });
        // Surface the server reason — "too large" or "must be an image or PDF" is
        // actionable; a generic failure is not.
        throw new Error(error.response?.data?.message || 'Failed to upload prescription');
    }
};

// The signed-in customer's own prescriptions. Replaces getMediaByAuthor, which read
// wp/v2/media and required admin rights. authorId is ignored; the server scopes by token.
export const getMediaByAuthor = async (authorId, page = 1, per_page = 10) => {
    const token = await getAuthToken();
    try {
        const response = await axios.get(`${PROJECT_URL}wp-json/custom/v1/me/prescriptions`, {
            params: { page, per_page },
            headers: { Authorization: `Bearer ${token}` },
        });
        return {
            data: response.data,
            total: response.headers['x-wp-total'] || response.data.length,
            totalPages: response.headers['x-wp-totalpages'] || 1,
        };
    } catch (error) {
        console.error('Error fetching prescriptions:', {
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch prescriptions');
    }
};

// Delete one of the caller's own prescriptions. MyPrescription.jsx previously had a
// delete button that showed a success toast without calling anything (BUG-3).
export const deleteOwnPrescription = async (id) => {
    const token = await getAuthToken();
    try {
        const response = await axios.delete(
            `${PROJECT_URL}wp-json/custom/v1/me/prescriptions/${id}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (error) {
        console.error('Error deleting prescription:', {
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to delete prescription');
    }
};


// Delete a media item from a Premio Folders folder
export async function deleteMediaFromFolder(id, folderName) {
    try {
        await mediaApi.delete(`${id}?force=true`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return { success: true, message: `Media item ${id} deleted from folder "${folderName}"` };
    } catch (error) {
        console.error('Error deleting media from Premio folder:', {
            id,
            folderName,
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            url: error.config?.url,
            headers: error.config?.headers,
        });
        throw new Error(error.response?.data?.message || 'Failed to delete media from folder');
    }
}



// Retrieve media from a Premio Folders folder
/*
export const getMediaByFolder = async (folderName, page = 1, per_page = 4) => {
    try {
        const folderId = await getFolderIdByName(folderName);
        const mediaResponse = await mediaApi.get('', {
            params: {
                media_folder: folderId,
                page,
                per_page,
            
            },
        });

        const mediaData = mediaResponse.data.map((item) => ({
            id: item.id,
            url: item.source_url,
            author: item.author,
            date: item.date,
        }));

        return {
            data: mediaData,
            total: parseInt(mediaResponse.headers['x-wp-total'] || mediaData.length),
            totalPages: parseInt(mediaResponse.headers['x-wp-totalpages'] || 1),
        };
    } catch (error) {
        console.error('Error fetching media by Premio folder:', {
            folderName,
            page,
            per_page,
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch media by folder');
    }
};*/


const MEDIA_CACHE_PREFIX = "media_cache_";         // Example: media_cache_Slider
const MEDIA_CACHE_TIME_PREFIX = "media_cache_time_";
const MEDIA_TTL = 1000 * 60 * 60 * 6; // 6 hours

export const getMediaByFolder = async (folderName, page = 1, per_page = 4) => {
    try {
        // Unique cache keys per folder
          const CACHE_KEY = `${MEDIA_CACHE_PREFIX}${folderName}_${page}_${per_page}`;
          const CACHE_TIME_KEY = `${MEDIA_CACHE_TIME_PREFIX}${folderName}_${page}_${per_page}`;
        // Read cache
        const cached = localStorage.getItem(CACHE_KEY);
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);

        if (cached) {
            const parsed = JSON.parse(cached);
            const age = Date.now() - Number(cachedTime);

            console.log(`Loaded media for ${folderName} from cache`);

            // Cache too old? Refresh in background
            if (age > MEDIA_TTL) {
                console.log(`Refreshing media for ${folderName} in background…`);
                refreshMediaInBackground(folderName, page, per_page);
            }

            return {
                data: parsed,
                total: parsed.length,
                totalPages: 1,
            };
        }

        // No cache → fetch fresh
        const folderId = await getFolderIdByName(folderName);
        const mediaResponse = await mediaApi.get('', {
            params: {
                media_folder: folderId,
                page,
                per_page,
            },
        });

        const mediaData = mediaResponse.data.map((item) => ({
            id: item.id,
            url: item.source_url,
            author: item.author,
            date: item.date,
        }));

        // Save to cache
        localStorage.setItem(CACHE_KEY, JSON.stringify(mediaData));
        localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());

        return {
            data: mediaData,
            total: parseInt(mediaResponse.headers['x-wp-total'] || mediaData.length),
            totalPages: parseInt(mediaResponse.headers['x-wp-totalpages'] || 1),
        };

    } catch (error) {
        console.error("Error fetching media:", error);
        throw new Error("Failed to fetch media");
    }
};


async function refreshMediaInBackground(folderName, page, per_page) {
    try {
        const folderId = await getFolderIdByName(folderName);
        const mediaResponse = await mediaApi.get('', {
            params: {
                media_folder: folderId,
                page,
                per_page,
            },
        });

        const mediaData = mediaResponse.data.map((item) => ({
            id: item.id,
            url: item.source_url,
            author: item.author,
            date: item.date,
        }));

        // Update cache silently
       //// localStorage.setItem(MEDIA_CACHE_PREFIX + folderName, JSON.stringify(mediaData));
        //.setItem(MEDIA_CACHE_TIME_PREFIX + folderName, Date.now().toString());
        const CACHE_KEY = `${MEDIA_CACHE_PREFIX}${folderName}_${page}_${per_page}`;
       const CACHE_TIME_KEY = `${MEDIA_CACHE_TIME_PREFIX}${folderName}_${page}_${per_page}`;

localStorage.setItem(CACHE_KEY, JSON.stringify(mediaData));
localStorage.setItem(CACHE_TIME_KEY, Date.now().toString());
        console.log(`Media cache updated for ${folderName}`);
    } catch (err) {
        console.warn(`Failed background refresh for ${folderName}`, err);
    }
}

// Get all reports. Kept in step with the copy in Api.js (see ARCH-1 — two
// parallel API layers means every change here has to be made twice).
//
// `params` added for BUG-6: see the note on the Api.js copy.
export async function getAllRetrieveProperties(route, params = {}) {
    try {
        const response = await request('GET', `${API_URL}/reports${route || ''}`, {}, params);
        return response.data;
    } catch (error) {
        console.error('Error fetching reports:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch reports');
    }
}